import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 *  MFA setup
 */
export default async function setupMFA(password: string) {
  const res = await fetchOrchidAPI("/api/users/v1/enable_mfa", {
    method: "POST",
    body: JSON.stringify({ password }),
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
